import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 移动端适配
import 'amfe-flexible'

// Vant UI 组件库
import Vant from 'vant'
import 'vant/lib/index.css'

// 微信 JS-SDK（用于小程序跳转等）
import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx

Vue.config.productionTip = false

Vue.use(Vant)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
